import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import { getAssignedNumbers } from '../../../../actions/EpikBoxes';
import { connect } from 'react-redux';

function BoxPortTabs({ user, portMode, boxDetails, onModeSelect }) {
  const token = localStorage.getItem('jwtToken') || null;

  return (
    <>
      {(user.role === 'admin' ||
        user.role === 'enterpriseAdmin' ||
        user.role === 'companyGroupManager') && (
        <ButtonGroup className="tab-group" style={{ width: '100%', margin: '0px' }}>
          <Button
            className={portMode === 'ports' ? 'active' : ''}
            onClick={() => onModeSelect('ports')}
            id="test-ports-tab"
          >
            Ports
          </Button>
        </ButtonGroup>
      )}
      {(user.role === 'superAdmin' ||
        user.role === 'companyGroupAdmin' ||
        user.role === 'supportEngineer') && (
        <ButtonGroup className="tab-group" style={{ width: '100%', margin: '0px' }}>
          {user.company.companyType !== 'manufacturer' && (
            <Button
              className={portMode === 'ports' ? 'active' : ''}
              onClick={() => onModeSelect('ports')}
              id="test-ports-tab"
            >
              Ports
            </Button>
          )}

          {/* <Button
            className={portMode === 'phones' ? 'active':''}
            onClick={() => onModeSelect('phones')}
            id="test-phones-tab"
          >
            Phones
          </Button> */}

          <Button
            id="test-epis-tab"
            className={portMode === 'epis' ? 'active' : ''}
            onClick={() => onModeSelect('epis')}
          >
            EPIs
          </Button>
          {boxDetails.features && boxDetails.features?.showPriTab && !boxDetails?.myEpik && (
            <Button
              className={portMode === 'pri' ? 'active' : ''}
              onClick={async () => {
                await getAssignedNumbers(
                  token,
                  boxDetails.assignedTo._id,
                  boxDetails.epikBoxUser._id,
                  false,
                );
                onModeSelect('pri');
              }}
              id="test-sip-pri-tab"
            >
              SIP | PRI
            </Button>
          )}

          <Button
            className={portMode === 'networking' ? 'active' : ''}
            onClick={async () => {
              onModeSelect('networking');
            }}
            id="test-networking-tab"
          >
            Networking
          </Button>

          <Button
            className={portMode === 'options' ? 'active' : ''}
            onClick={async () => {
              onModeSelect('options');
            }}
            id="test-options-tab"
          >
            Options
          </Button>
          <Button
            className={portMode === 'adminTools' ? 'active' : ''}
            onClick={async () => {
              onModeSelect('adminTools');
            }}
            id="test-admin-tools-tab"
          >
            Admin Tools
          </Button>
        </ButtonGroup>
      )}
    </>
  );
}
const mapDispatchToProps = dispatch => ({
  getAssignedNumbers: (token, cid, uid, priStatus) =>
    dispatch(getAssignedNumbers(token, cid, uid, priStatus)),
});

export default connect(mapDispatchToProps)(BoxPortTabs);
